module.exports = __webpack_public_path__ + "ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ba.svg
// module id = 690
// module chunks = 0